import {
  DSButton,
  DSCardWrapper,
} from "@components/design-system/molecules";
import {
  CompanionV2Message,
  useCompanionV2,
} from "@hooks/use-companion-v2";

export const NavProposalCard = ({
  message,
}: {
  message: CompanionV2Message;
}) => {
  const { acceptNavProposal, dismissNavProposal } = useCompanionV2();
  const proposal = message.navProposal;
  if (!proposal) return null;

  return (
    <div className="w-full flex px-sm my-xs">
      <div className="max-w-[80%]">
        <DSCardWrapper
          variant="info"
          padding="p-md"
          dataTestId="companion-nav-proposal-card"
        >
          <div className="flex flex-col gap-sm">
            <div className="flex flex-col gap-1">
              <div className="text-sm font-medium text-primary">
                Open {proposal.label}?
              </div>
              {proposal.reason && (
                <div className="text-xs text-secondary">
                  {proposal.reason}
                </div>
              )}
            </div>
            <div className="flex gap-2">
              <DSButton
                variant="primary"
                size="sm"
                onClick={() => acceptNavProposal(message.id)}
                dataTestId="companion-nav-proposal-accept"
              >
                Open
              </DSButton>
              <DSButton
                variant="cancel"
                size="sm"
                onClick={() => dismissNavProposal(message.id)}
                dataTestId="companion-nav-proposal-dismiss"
              >
                Not now
              </DSButton>
            </div>
          </div>
        </DSCardWrapper>
      </div>
    </div>
  );
};
